import { Typography } from '@mui/material';
import { EditIcon } from '../../../../assets/svg';
import { UserInfoContainer, AvatarContainer, CustomizableAvatar, EditIconOverlay } from '../UserAccountPanel.styles';
import { handleChoosePhotos } from '../UserAccountPanel.handlers';
import { useSelector, useDispatch } from 'react-redux';

const UserInfo = ({ employee }) => {
  const dispatch = useDispatch();
  // Get the most up-to-date employee data from Redux store
  const updatedEmployee =
    useSelector((state) => state.employees.employees.find((emp) => emp.id === employee.id)) || employee; // Fallback to props if not found in Redux

  return (
    <UserInfoContainer>
      <Typography variant="h4">{updatedEmployee.displayName}</Typography>
      <AvatarContainer>
        <CustomizableAvatar
          className="avatar"
          onClick={() => handleChoosePhotos(employee, dispatch)}
          size="large"
          alt={updatedEmployee.displayName}
          src={updatedEmployee.profileImageUrl}
        />
        <EditIconOverlay className="edit-icon">
          <EditIcon color="white" />
        </EditIconOverlay>
      </AvatarContainer>
      <Typography variant="subtitle1">{updatedEmployee.shiftTypes?.join(', ')}</Typography>
    </UserInfoContainer>
  );
};

export default UserInfo;
